@for (chapterId of chapterIds(); track chapterId; let i = $index) {
  <tt-chapter-widget
    #chapterElement
    class="smartbook-chapter-container"
    [attr.data-testid]="'smartbook-chapter_container-' + chapterId"
    [chapterId]="chapterId"
    [numbering]="!!numbering ? numbering + '.' + (i + 1).toString() : (i + 1).toString()" />
}
